import { Row } from "antd";
import { Message } from "./Message";
import { IMessage } from "../../../types/Message";
import { RefObject } from "react";

type ListProps = {
  conversationId: string;
  messages: IMessage[];
  anchor: RefObject<HTMLDivElement>;
  isArchived: boolean;
};

export const List = ({
  conversationId,
  messages,
  anchor,
  isArchived,
}: ListProps) => (
  <Row className="d-block w-100">
    {messages.map((item: any, i: number) => (
      <Message conversationId={conversationId} item={item} key={i} />
    ))}
    {isArchived && (
      <Row className="w-100">
        <span className="text-md title mt-0 mb-4 mx-auto">
          Conversation is closed and archived
        </span>
      </Row>
    )}
    <Row className="bot-ancher" ref={anchor} />
  </Row>
);
